"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initiatePeaks = void 0;
const merge_1 = __importDefault(require("lodash/merge"));
const nmr_processing_1 = require("nmr-processing");
function initiatePeaks(inputSpectrum, spectrum) {
    return (0, merge_1.default)({ values: [], options: {} }, inputSpectrum.peaks, {
        values: (0, nmr_processing_1.mapPeaks)(inputSpectrum?.peaks?.values || [], spectrum),
    });
}
exports.initiatePeaks = initiatePeaks;
